import { publicFetch, PublicApiError } from "../../api/public-fetch";

import type {
  SubmitAnswerRequest,
  SurveyStateResponse,
} from "./types";

// Re-export so callers can handle auth/status errors by instanceof.
export { PublicApiError };

// Map backend error statuses to typed state values so the UI can render the
// right empty state without throwing on expected non-200 responses.
async function fetchWithStateMapping(
  path: string,
  init?: RequestInit,
): Promise<SurveyStateResponse> {
  try {
    return await publicFetch<SurveyStateResponse>(path, init);
  } catch (e) {
    if (e instanceof PublicApiError) {
      if (e.status === 404) {
        return {
          state: "not_found",
          question_bank: null,
          answers_so_far: null,
          next_question_id: null,
          partner_name: null,
        };
      }
      if (e.status === 410) {
        return {
          state: "expired",
          question_bank: null,
          answers_so_far: null,
          next_question_id: null,
          partner_name: null,
        };
      }
    }
    throw e;
  }
}

export async function fetchSurveyState(token: string): Promise<SurveyStateResponse> {
  return fetchWithStateMapping(`/survey/pmf/${token}`);
}

export async function submitSurveyAnswer(
  token: string,
  body: SubmitAnswerRequest,
): Promise<SurveyStateResponse> {
  return fetchWithStateMapping(`/survey/pmf/${token}/answer`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export type { SurveyState, SurveyStateResponse, Question, QuestionOption, QuestionType, SubmitAnswerRequest } from "./types";
